<template>
  <div class="register absolute">
    <div>
    <div class="whiteBg" v-if="formItem === 1" style="padding-bottom:0.48rem;">
      <div class="title acea-row row-center-wrapper">
        <div
                class="item"
                :class="current === index ? 'on' : ''"
                v-for="(item, index) in navList"
                @click="navTap(index)"
                :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input
                      type="text"
                      placeholder="输入会员号/手机号码"
                      v-model="account"
                      @blur="accountBlur"
                      required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                      type="password"
                      placeholder="填写登录密码"
                      v-model="password"
                      required
              />
            </div>
          </div>
        </form>
        <div
                class="forgetPwd"
                @click="$router.push({ name: 'RetrievePassword' })"
        >
          <span class="iconfont icon-wenti"></span>忘记密码
        </div>
      </div>
      <div class="list" :hidden="current !== 1">


        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" maxlength="11" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
                    type="text"
                    placeholder="填写验证码"
                    class="codeIput"
                    v-model="captcha"
            />
            <button
                    class="code"
                    :disabled="disabled"
                    :class="disabled === true ? 'on' : ''"
                    @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
                    type="text"
                    placeholder="填写验证码"
                    class="codeIput"
                    v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current !== 1">登录</div>
      <div class="logon" @click="submit" :hidden="current === 1">登录</div>
      <div class="tip" style="display:none;">
        没有账号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div>
    </div>
    <div class="whiteBg" v-else>
      <div class="title">注册账号</div>
      <div class="list">


        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" maxlength="11" />
          </div>
        </div>

        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
                    type="text"
                    placeholder="姓名"
                    v-model="nickname"
                    maxlength="12"
            />
          </div>
        </div>
        <div class="item">
          <div style="position:relative;">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
                    type="text"
                    placeholder="推荐人手机号"
                    v-model="re_mobile"

                    maxlength="11"
                    v-on:blur="changeReMobile(value)"
            />
            <div style="position: absolute;right: 0rem;top: 0rem;">{{reMobileShow}}</div>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
                    type="password"
                    placeholder="登录密码(6~16位字母+数字)"
                    v-model="password"
            />
          </div>
        </div>

        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
                    type="text"
                    placeholder="填写验证码"
                    class="codeIput"
                    v-model="captcha"
            />
            <button
                    class="code"
                    :disabled="disabled"
                    :class="disabled === true ? 'on' : ''"
                    @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>


        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
                    type="text"
                    placeholder="填写验证码"
                    class="codeIput"
                    v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有账号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import sendVerifyCode from "@mixins/SendVerifyCode";

  import {
    login,
    loginMobile,
    registerVerify,
    register,
    getCodeApi,
      getUserOpenId,
    changeReMobile,
    getReMobile
  } from "@api/user";
  import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
  import { validatorDefaultCatch } from "@utils/dialog";
  import { getLogo } from "@api/public";
  import dayjs from "dayjs";
  import cookie from "@utils/store/cookie";
  import { VUE_APP_API_URL } from "@utils";
  import { pay,oAuth } from "@libs/wechat";
  import { isWeixin2 } from "@utils/index";
  const BACK_URL = "login_back_url";

  export default {
    name: "Login",
    mixins: [sendVerifyCode],
    data: function() {
      return {
        navList: ["账号登录", "快速登录"],
        current: 0,
        account: "",
          isWeixin: isWeixin2(),
        password: "",
          nickname:"",
        re_mobile:"",
        re_mobile_value:"",
        reMobileShow:'',
        captcha: "",
        formItem: 1,
        type: "login",
        logoUrl: "",
        keyCode: "",
        codeUrl: "",
        codeVal: "",
        isShowCode: false
      };
    },
    mounted: function() {
      this.getCode();
      this.getSpread();


    },
    methods: {
      accountBlur(){
        let that = this;
        let account = this.account;
        //去除字符串右边的空格
        account = account.replace(/\s*$/g, "");
        that.account = account;

      },
      getSpread(){
        let that = this;
        var spread = cookie.get("spread");//
        if(spread>0){
          getReMobile({
            spread: spread
          })
                  .then(res => {
                    that.re_mobile = res.data.re_mobile;
                    that.reMobileShow = res.data.reMobileShow;
                  })
                  .catch(res => {
                    this.$dialog.error(res.msg);
                  });
        }
      },

      again() {
        this.codeUrl =
                VUE_APP_API_URL +
                "/sms_captcha?" +
                "key=" +
                this.keyCode +
                Date.parse(new Date());
      },
      getCode() {
        getCodeApi()
                .then(res => {
                  this.keyCode = res.data.key;
                })
                .catch(res => {
                  this.$dialog.error(res.msg);
                });
      },

      async changeReMobile(){
        let  that= this;
        if(that.re_mobile){
          changeReMobile({
            re_mobile: that.re_mobile
          })
                  .then(res => {
                    that.reMobileShow = res.data.reMobileShow;
                  })
                  .catch(res => {
                    this.$dialog.error(res.msg);
                  });
        }

      },
      async loginMobile() {
        var that = this;
        const { account, captcha } = that;
        try {
          await that
                  .$validator({
                    account: [
                      required(required.message("手机号码")),
                      chs_phone(chs_phone.message())
                    ],
                    captcha: [
                      required(required.message("验证码")),
                      alpha_num(alpha_num.message("验证码"))
                    ]
                  })
                  .validate({ account, captcha });
        } catch (e) {
          return validatorDefaultCatch(e);
        }
        loginMobile({
          phone: that.account,
          captcha: that.captcha,
          spread: cookie.get("spread")
        }).then(res => {
          let data = res.data;
          cookie.set('login_u_account',data.account);
          cookie.set('order_act_account','');
              console.log('登录了吗')
              if(isWeixin2()){
                const backUrl = cookie.get(BACK_URL) || "/"
                cookie.set(BACK_URL,backUrl);

                cookie.set('loginaccount',data.loginaccount);
                cookie.set('loginpassword',data.logincode);
                oAuth();
              }else{

                let newTime = Math.round(new Date() / 1000);
                that.$store.commit(
                    "LOGIN",
                    data.token,
                    dayjs(data.expires_time) - newTime
                );

                const backUrl = cookie.get(BACK_URL) || "/";
                //cookie.remove(BACK_URL);
                that.$router.replace({ path: backUrl });
                /*if(!res.data.openid && isWeixin()){
                    const backUrl = cookie.get(BACK_URL) || "/"
                    cookie.set(BACK_URL,backUrl);
                    oAuth(res.data.uid);
                    /!*getUserOpenId().then(res => {
                          if(res.data.openid == '')
                      {
                          oAuth(res.data.uid);
                      }
                  });*!/
                }else{
                    const backUrl = cookie.get(BACK_URL) || "/";
                    cookie.remove(BACK_URL);
                    that.$router.replace({ path: backUrl });
                }*/
              }
          }).catch(res => {
            that.$dialog.error(res.msg);
          });
      },
      async register() {
        var that = this;
        const { account, captcha,nickname, password } = that;
        try {
          await that
                  .$validator({
                    account: [
                      required(required.message("手机号码")),
                      chs_phone(chs_phone.message())
                    ],
                    captcha: [
                      required(required.message("验证码")),
                      alpha_num(alpha_num.message("验证码"))
                    ],
                    nickname:[
                        required(required.message("姓名")),
                    ],
                    password: [
                      required(required.message("密码")),
                      attrs.range([6, 16], attrs.range.message("密码")),
                      alpha_num(alpha_num.message("密码"))
                    ]
                  })
                  .validate({ account, captcha,nickname, password });
        } catch (e) {
          return validatorDefaultCatch(e);
        }
        register({
          account: that.account,
          captcha: that.captcha,
          re_mobile:that.re_mobile,
          password: that.password,
            nickname:that.nickname,
          //spread: cookie.get("spread")
        })
                .then(res => {
                  that.$dialog.success(res.msg);
                  /*that.formItem = 1;*/

                  let newTime = Math.round(new Date() / 1000);
                  that.$store.commit(
                          "LOGIN",
                          res.data.token,
                          dayjs(res.data.expires_time) - newTime
                  );

                  /*if(isWeixin()){
                  oAuth(res.data.uid);
                  }*/

      /*getUserOpenId().then(res => {
                      if(res.data.openid == '')
                      {
                          oAuth(res.data.uid);
                      }
                  });*/
                   const backUrl = cookie.get(BACK_URL) || "/";
                  //cookie.remove(BACK_URL);
                  that.$router.replace({ path: backUrl });



                }).catch(res => {
                  that.$dialog.error(res.msg);
                });
      },
      async code() {
        var that = this;
        const { account } = that;
        try {
          await that
                  .$validator({
                    account: [
                      required(required.message("手机号码")),
                      chs_phone(chs_phone.message())
                    ]
                  })
                  .validate({ account });
        } catch (e) {
          return validatorDefaultCatch(e);
        }
        if (that.formItem == 2) that.type = "register";
        if (that.formItem == 1) that.type = "login";

        await registerVerify({
          phone: that.account,
          type: that.type,
          key: that.keyCode,
          code: that.codeVal
        })
                .then(res => {
                  that.$dialog.success(res.msg);
                  that.sendCode();
                })
                .catch(res => {
                  if (res.data.status === 402) {
                    that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
                    that.isShowCode = true;
                  }
                  that.$dialog.error(res.msg);
                });
      },
      navTap: function(index) {
        this.current = index;
      },
      async submit() {
        const { account, password, codeVal } = this;
        try {
          await this.$validator({
            account: [
              required(required.message("账号")),
              attrs.range([5, 16], attrs.range.message("账号")),
              alpha_num(alpha_num.message("账号"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              //alpha_num(alpha_num.message("密码"))
            ],
            codeVal: this.isShowCode
                    ? [
                      required(required.message("验证码")),
                      attrs.length(4, attrs.length.message("验证码")),
                      alpha_num(alpha_num.message("验证码"))
                    ]
                    : []
          }).validate({ account, password, codeVal });
        } catch (e) {
          return validatorDefaultCatch(e);
        }

        login({ account, password, code: codeVal })
                .then(({ data }) => {
                  cookie.set('order_act_account','');
                  cookie.set('login_u_account',data.account);
                  if(isWeixin2()){
                    const backUrl = cookie.get(BACK_URL) || "/"
                    cookie.set(BACK_URL,backUrl);

                    cookie.set('loginaccount',data.loginaccount);
                    cookie.set('loginpassword',data.logincode);
                    oAuth();
                  }else{
                      this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
                      const backUrl = cookie.get(BACK_URL) || "/";
                      //cookie.remove(BACK_URL);
                      this.$router.replace({path: backUrl});
                          /*if(!data.openid && isWeixin()){
                                const backUrl = cookie.get(BACK_URL) || "/"
                                cookie.set(BACK_URL,backUrl);
                                oAuth(data.uid);
                                /!*getUserOpenId().then(res => {
                                    if(res.data.openid == '')
                                {
                                    oAuth(res.data.uid);
                                }
                            });*!/
                          }else {
                              const backUrl = cookie.get(BACK_URL) || "/";
                              cookie.remove(BACK_URL);
                              this.$router.replace({path: backUrl});
                          }*/
                  }
                }).catch(e => {
                  this.$dialog.error(e.msg);
                });

      }
    }
  };
</script>
<style scoped>
  .code img {
    width: 100%;
    height: 100%;
  }
</style>
